//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import TalksMap from "@/utils/initMapTalks.js";
  import * as maptalks from "maptalks";
  import {workXuqiuDetail,workXuqiuAudit} from "@/api/gxInfo";
  import AuditRefuseDialog from "../components/AuditRefuseDialog";
  export default {
    name:"",
    data(){
      return {
        id:'',
        detail:{},
        workServerInfo:{},
        fileList:[],
        TalksMapDialog: new TalksMap(),
        dialogVisible:true
      }
    },
    components:{
      AuditRefuseDialog
    },
    created(){
      this.id = this.$route.query.id;
      this.getDetail();
    },
    mounted(){
      this.mapInit();
    },
    methods:{
      /**
       * @Author: likk
       * @description: 地图初始化
       * @param {*}
       * @return {*}
       */  
      mapInit(){
        this.TalksMapDialog.init("mapBox", 16);
      },

      /**
       * @Author: likk
       * @description: 向地图上添加自定义标注
       * @param {Array} markerList [lng,lat,imgUrl]
       * @return {*}
       */      
       addMarkerToMap(markerList){
        this.TalksMapDialog.map.setCenter({x:markerList[0].lng,y:markerList[0].lat});
        this.pic1Marker = new maptalks.VectorLayer("pic1Marker").addTo(
          this.TalksMapDialog.map
        );
        markerList.forEach( item => {
          const marker = new maptalks.Marker(
            [item.lng,item.lat],
            {
              symbol: [
                {
                  markerFile: item.imgUrl,
                  markerWidth: 22,
                  markerHeight: 32,
                  markerOpacity: 1
                  // info:item.info
                },
              ],
            }
          ).addTo(this.pic1Marker);
          // marker.on("click", (e) => {
            // let info = e.target._symbol[0].info;
            let info = item.info;
            let content='';
            if(info.type=='work'){
              content = `<div style='font-size:14px;color:#323333'>作业位置：${info.address}</div>`
            }else if(info.type=='service'){
              content = `<div style='font-size:14px;color:#323333'>机手位置：${info.address}</div>`
            }
            marker.setInfoWindow({
              single: false,
              content,
            });
            marker.openInfoWindow();
          // });
        })
        
      },
      /**
       * @Author: likk
       * @description: 获取详情数据
       * @param {*}
       * @return {*}
       */ 
      async getDetail(){
				const { data:{result:{ workServerInfo,fileList,...data}}} = await workXuqiuDetail(this.id);
          this.detail = data;
          this.workServerInfo = workServerInfo || {};
          this.fileList = fileList;
          let markerList = [{
            lng:data.lng,
            lat:data.lat,
            imgUrl:require('@/assets/gx/biaozhu_dingwei.png'),
            info:{
              type:'work',
              address:data.workAddress
            }
          }]
          if(workServerInfo && workServerInfo.lng && workServerInfo.lat){
            markerList.push({
              lng:workServerInfo.lng,
              lat:workServerInfo.lat,
              imgUrl:require('@/assets/gx/biaozhu_dingwei.png'),
              info:{
                type:'service',
                address:data.workAddress
              }
            })
          }
          this.addMarkerToMap(markerList);
      },
      
      /**
       * @Author: likk
       * @description: 审核
       * @param {Number} auditStatus 20:通过 30：不通过
       * @param {String} refuseReason 不通过理由 非必传
       * @return {*}
       */     
        handleAudit(auditStatus,refuseReason){
          workXuqiuAudit({
            auditStatus,
            id:this.id,
            refuseReason
          }).then( () => {
            this.$message.success('审核成功');
            this.$router.go(-1);
          })
        },  
        /**
         * @Author: likk
         * @description: 不通过
         * @param {*}
         * @return {*}
         */
         handleRefuse(){
          this.$refs.refuseDialog.handleVisible(true);
         },            
        /**
         * @Author: likk
         * @description: 不通过原因提交
         * @param {*}
         * @return {*}
         */        
        refuseReasonSubmit(data){
          this.handleAudit(30,data);
        }

    }
  }
